export const CLOSE_BUTTON_CLASS_NAME = 'hc-header--icon__close';
export const BACK_BUTTON_CLASS_NAME = 'hc-header--icon__back';
export const IFRAME_CLASS_NAME = 'community-iframe';

export const CLOSE_EVENT = 'close';
